module.exports = __webpack_public_path__ + "img/announcement.ca4c9599.svg";